import { isPossiblePhoneNumber } from 'libphonenumber-js'
import { urlToObject } from '../../utils/url'
import ENV from '../../utils/env'

const closeCurrentWindow = () => {
  try {
    // NOTE: wierd Chrome bug, when it doesn't close the window after first call
    //       https://support.google.com/chrome/thread/2241373?hl=en
    window.close()
    window.close()
    setTimeout(window.close, 50)
  } catch (e) {
    console.error('Couldnt close current window') // eslint-disable-line
  }
}

export const passInfoToOpenerOrRedirect = paymentMethodId => {
  let { return_url: returnUrl, parent_origin: parentOrigin } = urlToObject(window.location.href)
  if (returnUrl) {
    // Redirect to return url
    returnUrl = decodeURIComponent(returnUrl)
    // NOTE: returnUrl could have parameters already
    const withParams = returnUrl.indexOf('?') >= 0
    window.location.href = `${returnUrl}${
      withParams ? '&' : '?'
    }payment_method_id=${paymentMethodId}`
  } else if (window.opener && parentOrigin) {
    // NOTE: we must know parentOrigin to prevent postMessage error
    // Post data to parent and closing the window...
    window.opener.postMessage(paymentMethodId, decodeURIComponent(parentOrigin))
    closeCurrentWindow()
  } else {
    // eslint-disable-next-line
    console.error('Miss the return_url param in url, dunno where to redirect.')
    window.location.href = ENV.serverHost
    // closeCurrentWindow()
  }
}

// Remove strange double error message from server
export const prepareErrorMessage = (error = '') => {
  return error.replace('Error: ', '')
}


export function isUSPhoneNumber(phoneNumber) {
  return isPossiblePhoneNumber(phoneNumber, 'US') === true
}
